"use client";

import React from "react";
import { Handshake, PenTool, Mic, ArrowRight, Mail, Sparkles } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function CollabOpportunities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const opportunities = [{
    id: "item-1",
    title: "Brand Partnerships",
    icon: <Handshake className="size-5" />,
    content: "We love partnering with brands that share our values of sustainability, functionality, and mindful living. From sponsored blog posts to social media campaigns, we create authentic content that resonates with our audience of homeowners and design enthusiasts."
  }, {
    id: "item-2",
    title: "Guest Posting",
    icon: <PenTool className="size-5" />,
    content: "Are you an expert in home organization, interior design, or minimalist living? We welcome guest contributors who can offer fresh perspectives and practical advice to our community. Share your unique voice and grow your audience with us."
  }];
  return <section id="collab-opportunities" ref={ref} className={cn("bg-background py-24 transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid gap-16 lg:grid-cols-2 lg:gap-24">
          {}
          <div className="flex flex-col justify-center space-y-8">
            <div className="space-y-4">
              <div className="flex items-center gap-2 text-sm font-medium tracking-widest text-[var(--color-chart-1)] uppercase">
                <Sparkles className="size-4" />
                <span>Work With Us</span>
              </div>
              <h2 className="font-serif text-4xl font-light leading-tight text-foreground md:text-5xl lg:text-6xl">
                Let’s Create Something Beautiful Together
              </h2>
              <p className="text-lg leading-relaxed text-muted-foreground md:max-w-md">
                Whether you’re a brand looking to connect with a mindful audience
                or a fellow creative wanting to share your expertise, we’d love
                to hear from you.
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <Button asChild size="lg" className="rounded-full px-8">
                <Link to="/ContactPage">
                  Get in Touch <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full px-8 border-border hover:bg-secondary/50">
                <Link to="mailto:info@theorganizedspace.com">
                  <Mail className="mr-2 size-4" /> Email Us
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center">
            <div className="rounded-2xl border border-border/50 bg-card/30 p-6 shadow-sm backdrop-blur-sm md:p-10">
              <Accordion type="single" collapsible className="w-full">
                {opportunities.map((item, i) => <AccordionItem key={item.id} value={item.id} className="border-b-border/60 last:border-0" data-index={i}>
                    <AccordionTrigger className="py-6 text-lg font-medium text-foreground hover:text-[var(--color-chart-1)] hover:no-underline transition-colors">
                      <div className="flex items-center gap-4 text-left">
                        <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-[var(--color-chart-1)]/10 text-[var(--color-chart-1)]">
                          {item.icon}
                        </span>
                        <span>{item.title}</span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="pb-6 pl-[3.5rem] text-base leading-relaxed text-muted-foreground">
                      {item.content}
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>;
}